import React from 'react';
import PropTypes from 'prop-types';
import { HEAT_STRESS_FEATURES } from './index';
import './HeatStressPlansFeatures.less';

export default function HeatStressPlansFeatures({ onClick, currentTier = 'free' }) {
  const renderValue = (value) => {
    if (value === true) {
      return <span className="check"></span>
    } else if (value === false) {
      return <span className="x">✕</span>
    } else if (typeof value === 'string') {
      return <span className="text-value">{value}</span>
    }
    return null
  }

  const isActive = (tier) => currentTier === tier

  const renderTierHeaders = () => (
    <>
      <div className="feature-label-header"></div>
      <div className="tier-header free">
        <h3>Heat Stress</h3>
        <h4>Free</h4>
        {isActive('free') && <span className="active-badge">✓ Active</span>}
      </div>
      <div className="tier-header standard">
        <h3>Heat Stress</h3>
        <h4>Standard</h4>
        {isActive('standard') ? (
          <span className="active-badge">✓ Active</span>
        ) : (
          <button
            className="btn btn-primary"
            onClick={() => onClick('standard')}
          >
            Upgrade
          </button>
        )}
      </div>
      <div className="tier-header pro">
        <h3>Heat Stress</h3>
        <h4>Pro</h4>
        {isActive('pro') ? (
          <span className="active-badge">✓ Active</span>
        ) : (
          <button
            className="btn btn-primary"
            onClick={() => onClick('pro')}
          >
            Upgrade
          </button>
        )}
      </div>
      <div className="tier-header enterprise">
        <h3>Heat Stress</h3>
        <h4>Enterprise</h4>
        {isActive('enterprise') ? (
          <span className="active-badge">✓ Active</span>
        ) : (
          <button
            className="btn btn-primary"
            onClick={() => onClick('enterprise')}
          >
            Upgrade
          </button>
        )}
      </div>
    </>
  )

  return (
    <div className="payment-heat-stress-plans-features">
      <div className="features-header">
        <div className="header-row">
          {renderTierHeaders()}
        </div>
      </div>

      <div className="features-body">
        {HEAT_STRESS_FEATURES.map((feature, index) => (
          <div key={index} className="feature-row">
            <div className="feature-label">
              <strong>{feature.label}</strong>
              {feature.description && (
                <p className="feature-description">
                  {feature.description}
                </p>
              )}
            </div>
            <div className="feature-values">
              <div className="feature-value free">
                <span className="mobile-label">Free</span>
                {renderValue(feature.free)}
              </div>
              <div className="feature-value standard">
                <span className="mobile-label">Standard</span>
                {renderValue(feature.standard)}
              </div>
              <div className="feature-value pro">
                <span className="mobile-label">Pro</span>
                {renderValue(feature.pro)}
              </div>
              <div className="feature-value enterprise">
                <span className="mobile-label">Enterprise</span>
                {renderValue(feature.enterprise)}
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="features-footer">
        <div className="footer-row">
          {renderTierHeaders()}
        </div>
        <p className="footer-note">
          * Auto-add 100 SMS ($1.50 per 100 SMS, billed monthly) after available SMS are depleted. <a href="#" onClick={(e) => e.preventDefault()}>Learn more</a>
        </p>
      </div>
    </div>
  );
}

HeatStressPlansFeatures.propTypes = {
  onClick: PropTypes.func.isRequired,
  currentTier: PropTypes.oneOf(['free', 'standard', 'pro', 'enterprise'])
};

HeatStressPlansFeatures.defaultProps = {
  currentTier: 'free'
};

HeatStressPlansFeatures.displayName = 'HeatStressPlansFeatures';
